export function getGeolocation(options?: PositionOptions): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    const { geolocation } = window.navigator;

    if (!geolocation) {
      return reject();
    }

    geolocation.getCurrentPosition(resolve, reject, options);
  });
}
